var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtotop"},[_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/backtotop.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }